import { OneApiProvider as Provider } from "esa-hooks";
import { ReactNode, useMemo, type JSX } from "react";
import { getConfig } from "config";

const OneApiProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const config = useMemo(() => getConfig(), []);

  return (
    <Provider
      audience={config.api.audience}
      baseUrl={config.ebone.apiUrl}
      customHeaders={{
        "Esa-App-Version": config.app.version,
      }}
    >
      {children}
    </Provider>
  );
};
export default OneApiProvider;
